import React, { useState, useEffect } from 'react';
import DataTableDocumentActionModal from 'components/DataTableDocumentActionModal';
import { Grid } from '@mui/material';
import PropTypes from 'prop-types';
import FormField from 'layouts/applications/wizard/components/FormField';
import Swal from 'sweetalert2';
import axios from 'axios';

const CurrencyTypeModal = ({ show, handleClose, getData, document, onClose }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [formData, setFormData] = useState({
        name: '',
    });

    useEffect(() => {
        if (document) {
            setFormData({
                name: document.name || '',
            });
        } else {
            setFormData({
                name: '',
            });
        }
    }, [document]);

    const handleSubmit = async () => {
        try {
            setIsLoading(true);
            const url = document
                ? `${process.env.REACT_APP_SERVER_URL}/api/finance/currency-type/${document.id}/`
                : `${process.env.REACT_APP_SERVER_URL}/api/finance/currency-types/`;

            const response = document
                ? await axios.put(url, formData)
                : await axios.post(url, formData);

            getData();
            Swal.fire({
                icon: 'success',
                title: document ? 'Tipo de Moneda Actualizado' : 'Tipo de Moneda Creado',
                text: `El tipo de moneda ha sido ${document ? 'actualizado' : 'creado'} exitosamente`,
            });
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: `Ocurrió un error al ${document ? 'actualizar' : 'crear'} el tipo de moneda`,
            });
        } finally {
            handleClose();
            onClose && onClose();
            setIsLoading(false);
        }
    };

    const handleChange = (field) => (e) => {
        setFormData({ ...formData, [field]: e?.target?.value });
    };

    return (
        <DataTableDocumentActionModal
            show={show}
            handleClose={() => {
                handleClose();
                onClose && onClose();
            }}
            title={document ? "Editar Tipo de Moneda" : "Nuevo Tipo de Moneda"}
            handleSubmit={handleSubmit}
            isSubmitting={isLoading}
            submitText={document ? "Actualizar" : "Crear"}
        >
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <FormField
                        type="text"
                        label="Nombre del Tipo de Moneda"
                        value={formData.name}
                        onChange={handleChange('name')}
                        placeholder="Ingrese el nombre del tipo de moneda (ej. CLP/USD/EURO)"
                    />
                </Grid>
            </Grid>
        </DataTableDocumentActionModal>
    );
};

CurrencyTypeModal.propTypes = {
    show: PropTypes.bool,
    getData: PropTypes.func.isRequired,
    handleClose: PropTypes.func.isRequired,
    document: PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
    }),
    onClose: PropTypes.func,
};

export default CurrencyTypeModal;